import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-364c7b7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Wedding Party", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Get to know Regina and Dan's closest family and friends who will be participating in the ceremony on their big day!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WeddingPartyMember = _resolveComponent("WeddingPartyMember")!

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_WeddingPartyMember, {
      name: "Mariel Rodriguez",
      titles: ['Maid of Honor', 'Illustrator', 'Proud Filipino'],
      bio: "Mariel and Regina have a long, storied history, sharing the same crazy family members and feeling greatful and lucky to have such a great family.",
      imgSrc: "https://res.cloudinary.com/dpejnozsc/image/upload/f_auto,q_auto/v1/WeddingParty/ljby7qt3jntiulbehhzs",
      imgAltText: "Mariel and Regina smiling in a gondola"
    }),
    _createVNode(_component_WeddingPartyMember, {
      name: "Sayaka Shishido",
      titles: ['Bridesmaid', 'College Friend', 'Anime Nerd'],
      bio: "Sayaka and Regina met in freshman year at Simmons College and became fast friends over doodles in class and anime. Sayaka can definitely tell you about the time Regina slept through their shared class every week of freshman year.",
      imgSrc: "https://res.cloudinary.com/dpejnozsc/image/upload/f_auto,q_auto/v1/WeddingParty/dxibyh1iosp1oyzibzem",
      imgAltText: "Sayaka and Regina with both their mothers at their college graduation."
    }),
    _createVNode(_component_WeddingPartyMember, {
      name: "Victoria Moy",
      titles: ['Bridesmaid', 'Mother', 'Boba Eater'],
      bio: "Vicky and Regina met at Simmons College and could be heard laughing about life from miles and miles away. Even to this day, they basically sit together and laugh for no reason.",
      imgSrc: "https://res.cloudinary.com/dpejnozsc/image/upload/f_auto,q_auto/v1/WeddingParty/ihah2qntgadixkvvoctc",
      imgAltText: "Regina with Vicky on Vicky's wedding day."
    }),
    _createVNode(_component_WeddingPartyMember, {
      name: "Tony Ly",
      titles: ['Best Man', 'climber', 'tinkerer', 'dog lover'],
      bio: "Tony, a whicitan hailing from Texas, has been friends with Dan ever since the met rock climbing in Boston in 2014, just weeks before Dan met Regina. Tony, Dan, and Regina have been doing on EXTREME(ly) [get it?] fun outdoor climbing adventures ever since.",
      imgSrc: "https://res.cloudinary.com/dpejnozsc/image/upload/f_auto,q_auto/v1/WeddingParty/hk2glorrwhfoo8hlvbos",
      imgAltText: "Tony eating two ice creams at once"
    }),
    _createVNode(_component_WeddingPartyMember, {
      name: "Nick Valinski",
      titles: ['Groomsman', 'wood worker', 'poo poo pipe engineer'],
      bio: "Since having met during their freshman year on the Syracuse University Drumline back in '09, Nick and Dan have been building things and sharing moderatley inappropriate youtube links with eachother ever since.",
      imgSrc: "https://res.cloudinary.com/dpejnozsc/image/upload/f_auto,q_auto/v1/WeddingParty/evyskjtntr3iqr8th2v4",
      imgAltText: "Nick and Dan with some honey in the middle!"
    }),
    _createVNode(_component_WeddingPartyMember, {
      name: "George Boe",
      titles: ['Groomsman', 'photographer', 'climber', 'pro gardener'],
      bio: "George and Dan had a climbing gym meet-cute to rival Dan and Regina's, and have been going on professionally photographed climbing adventures and cooking difficult things in Denver ever since.",
      imgSrc: "https://res.cloudinary.com/dpejnozsc/image/upload/f_auto,q_auto/v1/WeddingParty/wovoxah5m1v4innbr0xy",
      imgAltText: "George and Dan having some victory beers on top of a mountain after rock climbing."
    }),
    _createVNode(_component_WeddingPartyMember, {
      name: "Kevin Patel",
      titles: ['Officiant', 'climber', 'brain doctor'],
      bio: "Having known both Dan and Regina from around the time they met, Kevin has joined them on many climbing and food adventures, and even though he's moved to LA, being on opposite ends of the country hasn't stopped their friendship!",
      imgSrc: "https://res.cloudinary.com/dpejnozsc/image/upload/f_auto,q_auto/v1/WeddingParty/lg3jbhqv45gertx0ut4r",
      imgAltText: "Kevin climbing on haloween in his giraffe costume"
    }),
    _hoisted_3,
    _hoisted_4
  ]))
}